const checkIsSmallWidth = (): boolean => window.innerWidth < 600;

export default checkIsSmallWidth;
